var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c("b-col", [
            _c("p", { staticClass: "description" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("account.registration.emailAlreadyAssociated")
                  ) +
                  "\n      "
              ),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { attrs: { tag: "article" } },
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("text-field", {
                attrs: {
                  value: _vm.email,
                  disabled: "",
                  label: _vm.$t("account.email"),
                  placeholder: _vm.$t("account.email"),
                  "input-type": "email",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { attrs: { tag: "article" } },
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("text-field", {
                attrs: {
                  value: _vm.password,
                  placeholder: _vm.$t("account.password"),
                  label: _vm.$t("account.password"),
                  "on-type": "",
                  "input-type": "password",
                },
                on: {
                  "update:value": function ($event) {
                    _vm.password = $event
                  },
                  enter: _vm.handleLogin,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "justify-content-center align-items-center" },
        [
          _c(
            "a",
            {
              staticClass:
                "bold mr-3 btn simple-button btn-white py-2 px-5 rounded-pill",
              attrs: { href: "#/reset-password" },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("account.forgotPassword")) + "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "simple-button",
            {
              attrs: {
                disabled: !_vm.password,
                "class-name": "py-2 px-5 rounded-pill",
                loading: _vm.loading,
                "loading-succeeded": _vm.loadingStatus,
              },
              on: { click: _vm.handleLogin },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("sidebar.sections.login")) + "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }